import { CSSProperties } from 'react';

/** Цвета одного тоста. Перекрывают и вариант, и `filled`, и классы вьюпорта. */
export type ToastAppearance = {
  /** Фон: любое значение CSS `background`, например цвет, токен или градиент. */
  background?: string;
  /** Цвет текста. */
  foreground?: string;
  /** Цвет полосы автозакрытия. */
  progressColor?: string;
};

const APPEARANCE_VARIABLES: Record<keyof ToastAppearance, string> = {
  background: '--toast-background',
  foreground: '--toast-foreground',
  progressColor: '--toast-progress-color',
};

export const appearanceToStyle = (appearance: ToastAppearance | undefined): CSSProperties =>
  Object.fromEntries(
    Object.entries(appearance ?? {})
      .filter(([key, value]) => key in APPEARANCE_VARIABLES && Boolean(value))
      .map(([key, value]) => [APPEARANCE_VARIABLES[key as keyof ToastAppearance], value])
  );
